import { useEffect, useMemo } from 'react';
import { useSnapshot } from 'valtio';

import { hasWizardBeenStarted } from '@cartwhl/common/utils/wizardPersistence';
import { useStartWizardWhenTargetReady } from '@cartwhl/ui/wizard';

import { projectStore, uiStore, userStore } from 'stores';

import {
  CANVAS_ON_MOTION_WIZARD_TARGET_IDS,
  CANVAS_ON_OPEN_WIZARD_TARGET_IDS,
  CANVAS_WIZARD_STARTED_KEYS,
  canvasOnOpenWizard,
  formatCanvasExportDestination,
  getCanvasOnMotionWizard,
  motionProjectHasTimelineClips,
} from './canvasWizards';

export default function CanvasWizardAutoLaunch() {
  const { loading: userLoading, userInfo } = useSnapshot(userStore.state);
  const { currentProject } = useSnapshot(projectStore.state);

  const userReady = !userLoading && Boolean(userInfo.userID);
  const projectReady =
    currentProject.status === 'ready' && Boolean(currentProject.data);

  const hasTimelineClips = motionProjectHasTimelineClips(currentProject.data);

  const shouldLaunchOnOpen =
    userReady &&
    projectReady &&
    !hasTimelineClips &&
    !hasWizardBeenStarted(
      CANVAS_WIZARD_STARTED_KEYS.onOpen,
      userInfo.wizardsStarted,
    );

  const shouldLaunchOnMotion =
    userReady &&
    projectReady &&
    hasTimelineClips &&
    !hasWizardBeenStarted(
      CANVAS_WIZARD_STARTED_KEYS.onMotion,
      userInfo.wizardsStarted,
    );

  const canvasOnMotionWizard = useMemo(
    () =>
      getCanvasOnMotionWizard(
        formatCanvasExportDestination(userInfo.productFocus),
      ),
    [userInfo.productFocus],
  );

  useEffect(() => {
    if (shouldLaunchOnOpen) {
      uiStore.setMotionFrontDoorMode('video');
    }
  }, [shouldLaunchOnOpen]);

  useStartWizardWhenTargetReady({
    enabled: shouldLaunchOnOpen,
    firstStepTargetId: CANVAS_ON_OPEN_WIZARD_TARGET_IDS.addMotion,
    definition: canvasOnOpenWizard,
  });

  useStartWizardWhenTargetReady({
    enabled: shouldLaunchOnMotion,
    firstStepTargetId: CANVAS_ON_MOTION_WIZARD_TARGET_IDS.timeline,
    definition: canvasOnMotionWizard,
  });

  return null;
}
